export const state = () => ({
  viewType: 'table'
})

export const mutations = {
  setViewType(state, viewType) {
    state.viewType = viewType
  }
}
